import React from 'react';
import { createSvgIcon, SvgIconProps } from '@mui/material';

export const AddLargeIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8333 9.16675H18.3333V10.8334H10.8333V18.3334H9.16663V10.8334H1.66663V9.16675H9.16663V1.66675H10.8333V9.16675Z" />
  </svg>,
  'AddLarge',
);

export const CloseLargeIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.82162 10.0001L2.32745 3.50597L3.50579 2.32764L9.99995 8.8218L16.4941 2.32764L17.6725 3.50597L11.1783 10.0001L17.6725 16.4943L16.4941 17.6726L9.99995 11.1785L3.50579 17.6726L2.32745 16.4943L8.82162 10.0001Z" />
  </svg>,
  'CloseLarge',
);

export const CloseIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99999 8.82251L14.125 4.69751L15.3033 5.87584L11.1783 10.0008L15.3033 14.1258L14.1242 15.3042L9.99916 11.1792L5.87499 15.3042L4.69666 14.125L8.82166 10L4.69666 5.87501L5.87499 4.69834L9.99999 8.82251Z" />
  </svg>,
  'Close',
);

export const ArrowDownSmallIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99993 10.9758L14.1249 6.85083L15.3033 8.03L9.99993 13.3333L4.69659 8.03L5.87493 6.85166L9.99993 10.9758Z" />
  </svg>,
  'ArrowDownSmall',
);

export const ArrowUpSmallIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99999 9.02341L5.87499 13.1484L4.69666 11.9701L9.99999 6.66675L15.3033 11.9701L14.125 13.1484L9.99999 9.02341Z" />
  </svg>,
  'ArrowUpSmall',
);

export const ArrowLeftSmallIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.02329 10.0001L13.1483 14.1251L11.97 15.3043L6.66663 10.0001L11.97 4.69678L13.1483 5.87511L9.02329 10.0001Z" />
  </svg>,
  'ArrowLeftSmall',
);

export const ArrowRightSmallIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.9767 10L6.85168 5.87501L8.03002 4.69751L13.3334 10L8.03002 15.3033L6.85168 14.1242L10.9767 10Z" />
  </svg>,
  'ArrowRightSmall',
);

export const ArrowDownIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8333 13.4768L15.3033 9.00683L16.4816 10.1852L9.99998 16.6668L3.51831 10.1852L4.69664 9.00683L9.16664 13.4768V3.3335H10.8333V13.4768Z" />
  </svg>,
  'ArrowDown',
);

export const CalendarIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.49996 0.833496V2.50016H12.5V0.833496H14.1666V2.50016H17.5C17.721 2.50016 17.9329 2.58796 18.0892 2.74424C18.2455 2.90052 18.3333 3.11248 18.3333 3.3335V16.6668C18.3333 16.8878 18.2455 17.0998 18.0892 17.2561C17.9329 17.4124 17.721 17.5002 17.5 17.5002H2.49996C2.27895 17.5002 2.06698 17.4124 1.9107 17.2561C1.75442 17.0998 1.66663 16.8878 1.66663 16.6668V3.3335C1.66663 3.11248 1.75442 2.90052 1.9107 2.74424C2.06698 2.58796 2.27895 2.50016 2.49996 2.50016H5.83329V0.833496H7.49996ZM16.6666 9.16683H3.33329V15.8335H16.6666V9.16683ZM5.83329 4.16683H3.33329V7.50016H16.6666V4.16683H14.1666V5.8335H12.5V4.16683H7.49996V5.8335H5.83329V4.16683Z" />
  </svg>,
  'Calendar',
);

export const CheckIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.33324 12.6418L15.9932 4.98267L17.1716 6.161L8.33324 14.9993L3.02991 9.696L4.20824 8.51767L8.33324 12.6418Z" />
  </svg>,
  'Check',
);

export const DeleteBinIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.1666 5.00008H18.3333V6.66675H16.6666V17.5001C16.6666 17.7211 16.5788 17.9331 16.4225 18.0893C16.2663 18.2456 16.0543 18.3334 15.8333 18.3334H4.16663C3.94561 18.3334 3.73365 18.2456 3.57737 18.0893C3.42109 17.9331 3.33329 17.7211 3.33329 17.5001V6.66675H1.66663V5.00008H5.83329V2.50008C5.83329 2.27907 5.92109 2.06711 6.07737 1.91083C6.23365 1.75455 6.44561 1.66675 6.66663 1.66675H13.3333C13.5543 1.66675 13.7663 1.75455 13.9225 1.91083C14.0788 2.06711 14.1666 2.27907 14.1666 2.50008V5.00008ZM15 6.66675H4.99996V16.6667H15V6.66675ZM7.49996 3.33341V5.00008H12.5V3.33341H7.49996Z" />
  </svg>,
  'DeleteBin',
);

export const DownloadIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8333 8.33333H15L9.99996 13.3333L4.99996 8.33333H9.16663V2.5H10.8333V8.33333ZM3.33329 15.8333H16.6666V10H18.3333V16.6667C18.3333 16.8877 18.2455 17.0996 18.0892 17.2559C17.9329 17.4122 17.721 17.5 17.5 17.5H2.49996C2.27895 17.5 2.06698 17.4122 1.9107 17.2559C1.75442 17.0996 1.66663 16.8877 1.66663 16.6667V10H3.33329V15.8333Z" />
  </svg>,
  'Download',
);

export const ErrorWarningIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.0001 18.3334C5.39758 18.3334 1.66675 14.6026 1.66675 10.0001C1.66675 5.39758 5.39758 1.66675 10.0001 1.66675C14.6026 1.66675 18.3334 5.39758 18.3334 10.0001C18.3334 14.6026 14.6026 18.3334 10.0001 18.3334ZM10.0001 16.6667C11.7682 16.6667 13.4639 15.9644 14.7141 14.7141C15.9644 13.4639 16.6667 11.7682 16.6667 10.0001C16.6667 8.23197 15.9644 6.53628 14.7141 5.28604C13.4639 4.03579 11.7682 3.33341 10.0001 3.33341C8.23197 3.33341 6.53628 4.03579 5.28604 5.28604C4.03579 6.53628 3.33341 8.23197 3.33341 10.0001C3.33341 11.7682 4.03579 13.4639 5.28604 14.7141C6.53628 15.9644 8.23197 16.6667 10.0001 16.6667ZM9.16675 12.5001H10.8334V14.1667H9.16675V12.5001ZM9.16675 5.83341H10.8334V10.8334H9.16675V5.83341Z" />
  </svg>,
  'ErrorWarning',
);

export const FilterIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.5 3.3335V5.00016H16.6667L12.5 11.2502V18.3335H7.5V11.2502L3.33333 5.00016H2.5V3.3335H17.5ZM5.33667 5.00016L9.16667 10.7452V16.6668H10.8333V10.7452L14.6633 5.00016H5.33667Z" />
  </svg>,
  'Filter',
);

export const FilterOffIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.92893 0.514648L21.0711 14.6568L19.6569 16.071L15.834 12.2486L15 13.4999V21.9999H9V13.4999L4 5.99993H3V3.99993L7.585 3.99965L5.51472 1.92886L6.92893 0.514648ZM9.585 5.99965L6.4037 5.99993L11 12.8944V19.9999H13V12.8944L14.392 10.8066L9.585 5.99965ZM21 3.99993V5.99993H20L18.085 8.87193L16.643 7.42893L17.5963 5.99993H15.213L13.213 3.99993H21Z"></path>
  </svg>,
  'Filter',
);

export const FunctionIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5H8.33333C8.55435 2.5 8.76631 2.5878 8.92259 2.74408C9.07887 2.90036 9.16667 3.11232 9.16667 3.33333V8.33333C9.16667 8.55435 9.07887 8.76631 8.92259 8.92259C8.76631 9.07887 8.55435 9.16667 8.33333 9.16667H3.33333C3.11232 9.16667 2.90036 9.07887 2.74408 8.92259C2.5878 8.76631 2.5 8.55435 2.5 8.33333V3.33333ZM2.5 11.6667C2.5 11.4457 2.5878 11.2337 2.74408 11.0774C2.90036 10.9211 3.11232 10.8333 3.33333 10.8333H8.33333C8.55435 10.8333 8.76631 10.9211 8.92259 11.0774C9.07887 11.2337 9.16667 11.4457 9.16667 11.6667V16.6667C9.16667 16.8877 9.07887 17.0996 8.92259 17.2559C8.76631 17.4122 8.55435 17.5 8.33333 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V11.6667ZM10.8333 3.33333C10.8333 3.11232 10.9211 2.90036 11.0774 2.74408C11.2337 2.5878 11.4457 2.5 11.6667 2.5H16.6667C16.8877 2.5 17.0996 2.5878 17.2559 2.74408C17.4122 2.90036 17.5 3.11232 17.5 3.33333V8.33333C17.5 8.55435 17.4122 8.76631 17.2559 8.92259C17.0996 9.07887 16.8877 9.16667 16.6667 9.16667H11.6667C11.4457 9.16667 11.2337 9.07887 11.0774 8.92259C10.9211 8.76631 10.8333 8.55435 10.8333 8.33333V3.33333ZM10.8333 11.6667C10.8333 11.4457 10.9211 11.2337 11.0774 11.0774C11.2337 10.9211 11.4457 10.8333 11.6667 10.8333H16.6667C16.8877 10.8333 17.0996 10.9211 17.2559 11.0774C17.4122 11.2337 17.5 11.4457 17.5 11.6667V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H11.6667C11.4457 17.5 11.2337 17.4122 11.0774 17.2559C10.9211 17.0996 10.8333 16.8877 10.8333 16.6667V11.6667ZM12.5 4.16667V7.5H15.8333V4.16667H12.5ZM12.5 12.5V15.8333H15.8333V12.5H12.5ZM4.16667 4.16667V7.5H7.5V4.16667H4.16667ZM4.16667 12.5V15.8333H7.5V12.5H4.16667Z" />
  </svg>,
  'Function',
);

export const HomeIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8333 15.8334H15.8333V8.31508L10 3.77842L4.16667 8.31508V15.8334H9.16667V10.8334H10.8333V15.8334ZM17.5 16.6668C17.5 16.8878 17.4122 17.0997 17.2559 17.256C17.0996 17.4123 16.8877 17.5001 16.6667 17.5001H3.33333C3.11232 17.5001 2.90036 17.4123 2.74408 17.256C2.5878 17.0997 2.5 16.8878 2.5 16.6668V7.90842C2.49991 7.78143 2.52885 7.6561 2.5846 7.542C2.64035 7.4279 2.72143 7.32805 2.82167 7.25008L9.48833 2.06425C9.63462 1.95045 9.81467 1.88867 10 1.88867C10.1853 1.88867 10.3654 1.95045 10.5117 2.06425L17.1783 7.25008C17.2786 7.32805 17.3597 7.4279 17.4154 7.542C17.4712 7.6561 17.5001 7.78143 17.5 7.90842V16.6668Z" />
  </svg>,
  'Home',
);

export const SettingsIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.78336 14.1668C2.43079 13.5577 2.15667 12.9064 1.96753 12.2285C2.37866 12.0195 2.72396 11.7008 2.96523 11.3078C3.2065 10.9147 3.33433 10.4626 3.33459 10.0014C3.33485 9.54015 3.20752 9.08786 2.96669 8.69452C2.72586 8.30119 2.38092 7.98214 1.97003 7.77267C2.34649 6.41066 3.06344 5.16689 4.05336 4.1585C4.44012 4.41017 4.88898 4.54989 5.35024 4.5622C5.81151 4.5745 6.26718 4.4589 6.6668 4.22821C7.06642 3.99751 7.39439 3.66072 7.61441 3.25512C7.83442 2.84952 7.9379 2.39095 7.91336 1.93017C9.28186 1.57679 10.7178 1.57765 12.0859 1.93267C12.0618 2.39324 12.1656 2.85148 12.3859 3.2567C12.6061 3.66193 12.9341 3.99834 13.3336 4.22873C13.7331 4.45911 14.1886 4.57449 14.6496 4.56209C15.1107 4.5497 15.5593 4.41002 15.9459 4.1585C16.9346 5.16784 17.6522 6.41081 18.0317 7.77184C17.6206 7.98092 17.2754 8.29965 17.0342 8.69276C16.793 9.08587 16.6652 9.53804 16.6651 9.99924C16.6649 10.4604 16.7923 10.9127 17.0332 11.306C17.2741 11.6993 17.6191 12.0183 18.03 12.2277C17.6533 13.5898 16.9361 14.8335 15.9459 15.8418C15.5591 15.5902 15.1102 15.4504 14.649 15.4381C14.1877 15.4258 13.732 15.5414 13.3324 15.7721C12.9328 16.0028 12.6048 16.3396 12.3848 16.7452C12.1648 17.1508 12.0613 17.6094 12.0859 18.0702C10.7174 18.4238 9.2815 18.4232 7.91336 18.0685C7.93746 17.608 7.83371 17.1498 7.61361 16.7446C7.3935 16.3394 7.0656 16.0029 6.66618 15.7725C6.26676 15.542 5.81138 15.4265 5.3504 15.4388C4.88943 15.451 4.44082 15.5905 4.0542 15.8418C3.5614 15.3393 3.13495 14.7765 2.78336 14.1668ZM7.4992 14.3302C8.38727 14.8423 9.05497 15.6643 9.3742 16.6385C9.79003 16.6777 10.2075 16.6785 10.6234 16.6402C10.9423 15.6654 11.61 14.8428 12.4984 14.3302C13.3864 13.8167 14.4328 13.6493 15.4367 13.8602C15.6784 13.5202 15.8867 13.1577 16.06 12.7785C15.3765 12.0146 14.9991 11.0252 15 10.0002C15 8.95017 15.3917 7.96934 16.0609 7.22184C15.8862 6.84285 15.677 6.48076 15.4359 6.14017C14.4328 6.35043 13.3874 6.18307 12.5 5.67017C11.612 5.15798 10.9443 4.33599 10.625 3.36184C10.2084 3.32267 9.7917 3.32184 9.37503 3.361C9.05591 4.33546 8.38821 5.15778 7.50003 5.67017C6.61201 6.18369 5.56559 6.35107 4.5617 6.14017C4.32003 6.48017 4.1117 6.84267 3.9392 7.22184C4.623 7.98564 5.00077 8.97499 5.00003 10.0002C5.00003 11.0502 4.60753 12.031 3.9392 12.7785C4.1139 13.1575 4.32311 13.5196 4.5642 13.8602C5.56729 13.6499 6.6127 13.8173 7.50003 14.3302M10 12.5002C9.33699 12.5002 8.7011 12.2368 8.23226 11.7679C7.76342 11.2991 7.50003 10.6632 7.50003 10.0002C7.50003 9.33713 7.76342 8.70124 8.23226 8.2324C8.7011 7.76356 9.33699 7.50017 10 7.50017C10.6631 7.50017 11.299 7.76356 11.7678 8.2324C12.2366 8.70124 12.5 9.33713 12.5 10.0002C12.5 10.6632 12.2366 11.2991 11.7678 11.7679C11.299 12.2368 10.6631 12.5002 10 12.5002ZM10 10.8335C10.221 10.8335 10.433 10.7457 10.5893 10.5894C10.7456 10.4331 10.8334 10.2212 10.8334 10.0002C10.8334 9.77916 10.7456 9.56719 10.5893 9.41091C10.433 9.25463 10.221 9.16684 10 9.16684C9.77902 9.16684 9.56705 9.25463 9.41077 9.41091C9.25449 9.56719 9.1667 9.77916 9.1667 10.0002C9.1667 10.2212 9.25449 10.4331 9.41077 10.5894C9.56705 10.7457 9.77902 10.8335 10 10.8335Z" />
  </svg>,
  'Settings',
);

export const SearchIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.16663 1.66675C13.3066 1.66675 16.6666 5.02675 16.6666 9.16675C16.6666 13.3067 13.3066 16.6667 9.16663 16.6667C5.02663 16.6667 1.66663 13.3067 1.66663 9.16675C1.66663 5.02675 5.02663 1.66675 9.16663 1.66675ZM9.16663 15.0001C12.3891 15.0001 15 12.3892 15 9.16675C15 5.94425 12.3891 3.33341 9.16663 3.33341C5.94413 3.33341 3.33329 5.94425 3.33329 9.16675C3.33329 12.3892 5.94413 15.0001 9.16663 15.0001ZM16.2375 15.0592L18.595 17.4159L17.4158 18.5951L15.0591 16.2376L16.2375 15.0592Z" />
  </svg>,
  'Search',
);

export const StackIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.7358 12.6667L17.7383 13.2675C17.8001 13.3045 17.8512 13.3569 17.8868 13.4195C17.9223 13.4822 17.9409 13.553 17.9409 13.625C17.9409 13.697 17.9223 13.7678 17.8868 13.8305C17.8512 13.8931 17.8001 13.9455 17.7383 13.9825L10.4283 18.3675C10.2989 18.445 10.1508 18.486 9.99996 18.486C9.84909 18.486 9.70105 18.445 9.57163 18.3675L2.26246 13.9833C2.20067 13.9463 2.14952 13.894 2.114 13.8313C2.07848 13.7686 2.05981 13.6979 2.05981 13.6258C2.05981 13.5538 2.07848 13.483 2.114 13.4204C2.14952 13.3577 2.20067 13.3053 2.26246 13.2683L3.26413 12.6675L9.99996 16.7083L16.7358 12.6667ZM16.7358 8.75L17.7383 9.35083C17.8001 9.38782 17.8512 9.4402 17.8868 9.50286C17.9223 9.56552 17.9409 9.63631 17.9409 9.70833C17.9409 9.78035 17.9223 9.85114 17.8868 9.9138C17.8512 9.97646 17.8001 10.0288 17.7383 10.0658L9.99996 14.7075L2.26246 10.0658C2.20067 10.0288 2.14952 9.97646 2.114 9.9138C2.07848 9.85114 2.05981 9.78035 2.05981 9.70833C2.05981 9.63631 2.07848 9.56552 2.114 9.50286C2.14952 9.4402 2.20067 9.38782 2.26246 9.35083L3.26413 8.75L9.99996 12.7917L16.7358 8.75ZM10.4291 1.09083L17.7375 5.47583C17.7993 5.51283 17.8504 5.56521 17.8859 5.62786C17.9214 5.69052 17.9401 5.76131 17.9401 5.83333C17.9401 5.90535 17.9214 5.97615 17.8859 6.0388C17.8504 6.10146 17.7993 6.15384 17.7375 6.19083L9.99996 10.8325L2.26246 6.19166C2.20067 6.15467 2.14952 6.10229 2.114 6.03963C2.07848 5.97698 2.05981 5.90619 2.05981 5.83416C2.05981 5.76214 2.07848 5.69135 2.114 5.62869C2.14952 5.56604 2.20067 5.51366 2.26246 5.47666L9.57079 1.09166C9.7004 1.01379 9.84876 0.972656 9.99996 0.972656C10.1512 0.972656 10.2995 1.01296 10.4291 1.09083ZM9.99996 2.77666L4.90579 5.83333L9.99996 8.89L15.0941 5.83333L9.99996 2.77666Z" />
  </svg>,
  'Stack',
);

export const UserIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.33331 18.3335C3.33331 16.5654 4.03569 14.8697 5.28593 13.6195C6.53618 12.3692 8.23187 11.6668 9.99998 11.6668C11.7681 11.6668 13.4638 12.3692 14.714 13.6195C15.9643 14.8697 16.6666 16.5654 16.6666 18.3335H15C15 17.0074 14.4732 15.7356 13.5355 14.798C12.5978 13.8603 11.3261 13.3335 9.99998 13.3335C8.6739 13.3335 7.40213 13.8603 6.46445 14.798C5.52676 15.7356 4.99998 17.0074 4.99998 18.3335H3.33331ZM9.99998 10.8335C7.23748 10.8335 4.99998 8.596 4.99998 5.8335C4.99998 3.071 7.23748 0.833496 9.99998 0.833496C12.7625 0.833496 15 3.071 15 5.8335C15 8.596 12.7625 10.8335 9.99998 10.8335ZM9.99998 9.16683C11.8416 9.16683 13.3333 7.67516 13.3333 5.8335C13.3333 3.99183 11.8416 2.50016 9.99998 2.50016C8.15831 2.50016 6.66665 3.99183 6.66665 5.8335C6.66665 7.67516 8.15831 9.16683 9.99998 9.16683Z" />
  </svg>,
  'User',
);

export const MenuIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 3.33325H17.5V4.99992H2.5V3.33325ZM2.5 9.16658H17.5V10.8333H2.5V9.16658ZM2.5 14.9999H17.5V16.6666H2.5V14.9999Z" />
  </svg>,
  'Menu',
);

export const FileListIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.6667 18.3334H3.33333C2.8731 18.3334 2.5 17.9603 2.5 17.5001V2.50008C2.5 2.03985 2.8731 1.66675 3.33333 1.66675H16.6667C17.1269 1.66675 17.5 2.03985 17.5 2.50008V17.5001C17.5 17.9603 17.1269 18.3334 16.6667 18.3334ZM15.8333 16.6667V3.33341H4.16667V16.6667H15.8333ZM6.66667 5.83341H13.3333V7.50008H6.66667V5.83341ZM6.66667 9.16675H13.3333V10.8334H6.66667V9.16675ZM6.66667 12.5001H13.3333V14.1667H6.66667V12.5001Z" />
  </svg>,
  'FileList',
);

export const FolderChartIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.3451 4.16667H17.5C17.9602 4.16667 18.3333 4.53977 18.3333 5V16.6667C18.3333 17.1269 17.9602 17.5 17.5 17.5H2.49996C2.03973 17.5 1.66663 17.1269 1.66663 16.6667V3.33333C1.66663 2.8731 2.03973 2.5 2.49996 2.5H8.67846L10.3451 4.16667ZM3.33329 4.16667V15.8333H16.6666V5.83333H9.65479L7.98812 4.16667H3.33329ZM9.16663 7.5H10.8333V14.1667H9.16663V7.5ZM12.5 10H14.1666V14.1667H12.5V10ZM5.83329 11.6667H7.49996V14.1667H5.83329V11.6667Z" />
  </svg>,
  'FolderChart',
);

export const LayoutIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.49996 17.5C2.03973 17.5 1.66663 17.1269 1.66663 16.6667V3.33333C1.66663 2.8731 2.03973 2.5 2.49996 2.5H17.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333V16.6667C18.3333 17.1269 17.9602 17.5 17.5 17.5H2.49996ZM12.5 8.33333H3.33329V15.8333H12.5V8.33333ZM16.6666 8.33333H14.1666V15.8333H16.6666V8.33333ZM16.6666 4.16667H3.33329V6.66667H16.6666V4.16667Z" />
  </svg>,
  'Layout',
);

export const NotificationIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 8.33341C15 5.57199 12.7614 3.33341 9.99996 3.33341C7.23853 3.33341 4.99996 5.57199 4.99996 8.33341V15.0001H15V8.33341ZM16.6666 15.5557L17 16.0001C17.138 16.1842 17.1007 16.4453 16.9166 16.5834C16.8445 16.6375 16.7568 16.6667 16.6666 16.6667H3.33329C3.10318 16.6667 2.91663 16.4802 2.91663 16.2501C2.91663 16.1599 2.94587 16.0722 2.99996 16.0001L3.33329 15.5557V8.33341C3.33329 4.65151 6.31806 1.66675 9.99996 1.66675C13.6819 1.66675 16.6666 4.65151 16.6666 8.33341V15.5557ZM7.91663 17.5001H12.0833C12.0833 18.6507 11.1505 19.5834 9.99996 19.5834C8.84938 19.5834 7.91663 18.6507 7.91663 17.5001Z" />
  </svg>,
  'Notification',
);

export const RoadMapIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.33329 5.11897V15.8057L7.55393 13.9968L12.554 16.4968L16.6666 14.7343V4.04753L17.7525 3.58217C17.964 3.49152 18.209 3.58949 18.2996 3.80101C18.3218 3.85288 18.3333 3.90872 18.3333 3.96514V15.8333L12.5 18.3333L7.49996 15.8333L2.24743 18.0843C2.03591 18.175 1.79097 18.077 1.70032 17.8655C1.67808 17.8137 1.66663 17.7578 1.66663 17.7013V5.83325L3.33329 5.11897ZM13.5355 9.36875L9.99996 12.9043L6.46443 9.36875C4.5118 7.41616 4.5118 4.25034 6.46443 2.29772C8.41704 0.345096 11.5829 0.345096 13.5355 2.29772C15.4881 4.25034 15.4881 7.41616 13.5355 9.36875ZM9.99996 10.5473L12.357 8.19028C13.6587 6.88853 13.6587 4.77798 12.357 3.47623C11.0552 2.17448 8.94471 2.17448 7.64293 3.47623C6.34119 4.77798 6.34119 6.88853 7.64293 8.19028L9.99996 10.5473Z" />
  </svg>,
  'RoadMap',
);

export const DeclarationIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.33337 0.833252V3.33325H0.833374V4.99992H3.33337V7.49992H5.00004V4.99992H7.50004V3.33325H5.00004V0.833252H3.33337ZM2.50004 16.6721V9.16658H4.16671V15.8333H10.8334V11.6666C10.8334 11.2083 11.2084 10.8333 11.6667 10.8333L15.8334 10.8324V4.16659H9.16671V2.49992H16.6722C17.1294 2.49992 17.5 2.87972 17.5 3.33531V12.4999L12.5 17.4966L3.33522 17.4999C2.87396 17.4999 2.50004 17.1292 2.50004 16.6721ZM15.1425 12.4991L12.5 12.4999V15.1408L15.1425 12.4991Z" />
  </svg>,
  'Declaration',
);

export const ListViewIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.66663 3.33333C1.66663 2.8731 2.03973 2.5 2.49996 2.5H17.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333V16.6667C18.3333 17.1269 17.9602 17.5 17.5 17.5H2.49996C2.03973 17.5 1.66663 17.1269 1.66663 16.6667V3.33333ZM3.33329 4.16667V15.8333H16.6666V4.16667H3.33329ZM4.99996 5.83333H6.66663V7.5H4.99996V5.83333ZM6.66663 9.16667H4.99996V10.8333H6.66663V9.16667ZM4.99996 12.5H6.66663V14.1667H4.99996V12.5ZM15 5.83333H8.33329V7.5H15V5.83333ZM8.33329 12.5H15V14.1667H8.33329V12.5ZM15 9.16667H8.33329V10.8333H15V9.16667Z" />
  </svg>,
  'ListView',
);

export const ShareBoxIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.33333 2.5V4.16667H4.16667V15.8333H15.8333V11.6667H17.5V16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5H8.33333ZM14.6548 4.16667H10.8333V2.5H17.5V9.16667H15.8333V5.34517L10 11.1785L8.8215 10L14.6548 4.16667Z" />
  </svg>,
  'ShareBox',
);

export const MoreFillIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 2.5C9.08337 2.5 8.33337 3.25 8.33337 4.16667C8.33337 5.08333 9.08337 5.83333 10 5.83333C10.9167 5.83333 11.6667 5.08333 11.6667 4.16667C11.6667 3.25 10.9167 2.5 10 2.5ZM10 14.1667C9.08337 14.1667 8.33337 14.9167 8.33337 15.8333C8.33337 16.75 9.08337 17.5 10 17.5C10.9167 17.5 11.6667 16.75 11.6667 15.8333C11.6667 14.9167 10.9167 14.1667 10 14.1667ZM10 8.33333C9.08337 8.33333 8.33337 9.08333 8.33337 10C8.33337 10.9167 9.08337 11.6667 10 11.6667C10.9167 11.6667 11.6667 10.9167 11.6667 10C11.6667 9.08333 10.9167 8.33333 10 8.33333Z" />
  </svg>,
  'MoreFill',
);

export const LayoutGridIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.5 2.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333V16.6667C18.3333 17.1269 17.9602 17.5 17.5 17.5H2.49996C2.03973 17.5 1.66663 17.1269 1.66663 16.6667V3.33333C1.66663 2.8731 2.03973 2.5 2.49996 2.5H17.5ZM9.16663 10.8333H3.33329V15.8333H9.16663V10.8333ZM16.6666 10.8333H10.8333V15.8333H16.6666V10.8333ZM9.16663 4.16667H3.33329V9.16667H9.16663V4.16667ZM16.6666 4.16667H10.8333V9.16667H16.6666V4.16667Z" />
  </svg>,
  'LayoutGrid',
);

export const GlobalIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99996 18.3334C5.39758 18.3334 1.66663 14.6024 1.66663 10.0001C1.66663 5.39771 5.39758 1.66675 9.99996 1.66675C14.6023 1.66675 18.3333 5.39771 18.3333 10.0001C18.3333 14.6024 14.6023 18.3334 9.99996 18.3334ZM8.09164 16.3896C7.28948 14.6883 6.79773 12.8119 6.68938 10.8334H3.38487C3.71496 13.4805 5.59695 15.6457 8.09164 16.3896ZM8.35888 10.8334C8.48421 12.8657 9.06479 14.7748 9.99996 16.4601C10.9351 14.7748 11.5157 12.8657 11.641 10.8334H8.35888ZM16.615 10.8334H13.3105C13.2022 12.8119 12.7105 14.6883 11.9083 16.3896C14.403 15.6457 16.285 13.4805 16.615 10.8334ZM3.38487 9.16675H6.68938C6.79773 7.18822 7.28948 5.31181 8.09164 3.61055C5.59695 4.35452 3.71496 6.51966 3.38487 9.16675ZM8.35888 9.16675H11.641C11.5157 7.13443 10.9351 5.22529 9.99996 3.54007C9.06479 5.22529 8.48421 7.13443 8.35888 9.16675ZM11.9083 3.61055C12.7105 5.31181 13.2022 7.18822 13.3105 9.16675H16.615C16.285 6.51966 14.403 4.35452 11.9083 3.61055Z" />
  </svg>,
  'Global',
);

export const LogoutBoxIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.16671 18.3334C3.70647 18.3334 3.33337 17.9603 3.33337 17.5001V2.50008C3.33337 2.03985 3.70647 1.66675 4.16671 1.66675H15.8334C16.2936 1.66675 16.6667 2.03985 16.6667 2.50008V5.00008H15V3.33341H5.00004V16.6667H15V15.0001H16.6667V17.5001C16.6667 17.9603 16.2936 18.3334 15.8334 18.3334H4.16671ZM15 13.3334V10.8334H9.16671V9.16675H15V6.66675L19.1667 10.0001L15 13.3334Z" />
  </svg>,
  'LogoutBox',
);

export const EyeCloseIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.78561 15.6515L6.17573 15.2201L6.83196 12.7711C5.84103 12.4061 4.93055 11.8748 4.13434 11.2111L2.3399 13.0055L1.16139 11.827L2.95583 10.0326C1.96322 8.84184 1.26683 7.39547 0.979858 5.80674L2.61993 5.50854C3.25245 9.01042 6.31613 11.6667 10.0002 11.6667C13.6843 11.6667 16.748 9.01042 17.3805 5.50854L19.0206 5.80674C18.7336 7.39547 18.0372 8.84184 17.0446 10.0326L18.839 11.827L17.6605 13.0055L15.8661 11.2111C15.0699 11.8748 14.1594 12.4061 13.1685 12.7711L13.8247 15.2201L12.2149 15.6515L11.5584 13.2014C11.052 13.2882 10.5314 13.3333 10.0002 13.3333C9.46913 13.3333 8.94846 13.2882 8.44212 13.2014L7.78561 15.6515Z" />
  </svg>,
  'EyeClose',
);

export const EditIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.34517 13.2418L13.7969 4.78997L12.6184 3.61145L4.16667 12.0633V13.2418H5.34517ZM6.03553 14.9084H2.5V11.3728L12.0292 1.84368C12.3547 1.51825 12.8822 1.51825 13.2077 1.84368L15.5647 4.20071C15.8902 4.52614 15.8902 5.05378 15.5647 5.37922L6.03553 14.9084ZM2.5 16.5751H17.5V18.2418H2.5V16.5751Z" />
  </svg>,
  'Edit',
);

export const CameraIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.66669 5.00081C1.66669 4.54017 2.04611 4.16675 2.49319 4.16675H17.5069C17.9634 4.16675 18.3334 4.53727 18.3334 5.00081V16.666C18.3334 17.1267 17.9539 17.5001 17.5069 17.5001H2.49319C2.03673 17.5001 1.66669 17.1296 1.66669 16.666V5.00081ZM3.33335 5.83341V15.8334H16.6667V5.83341H3.33335ZM11.6667 13.3334C13.0474 13.3334 14.1667 12.2142 14.1667 10.8334C14.1667 9.45266 13.0474 8.33341 11.6667 8.33341C10.2859 8.33341 9.16669 9.45266 9.16669 10.8334C9.16669 12.2142 10.2859 13.3334 11.6667 13.3334ZM11.6667 15.0001C9.36552 15.0001 7.50002 13.1346 7.50002 10.8334C7.50002 8.53225 9.36552 6.66675 11.6667 6.66675C13.9679 6.66675 15.8334 8.53225 15.8334 10.8334C15.8334 13.1346 13.9679 15.0001 11.6667 15.0001ZM3.33335 1.66675H8.33335V3.33341H3.33335V1.66675Z" />
  </svg>,
  'Camera',
);

export const DownloadCloudIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8333 10.8334V15.4876L12.357 13.9646L13.5355 15.1431L9.99998 18.6786L6.46445 15.1431L7.64295 13.9646L9.16665 15.4876V10.8334H10.8333ZM9.99998 1.66675C12.9945 1.66675 15.462 3.92309 15.7951 6.82837C17.7381 7.3597 19.1666 9.13808 19.1666 11.2501C19.1666 13.6407 17.3363 15.6039 15.0005 15.8147L15.0007 14.1371C16.4138 13.9346 17.5 12.7192 17.5 11.2501C17.5 9.63925 16.1941 8.33341 14.5833 8.33341C14.4093 8.33341 14.2389 8.34866 14.0739 8.37841C14.1346 8.09525 14.1666 7.8014 14.1666 7.50008C14.1666 5.1989 12.3011 3.33341 9.99998 3.33341C7.6988 3.33341 5.83331 5.1989 5.83331 7.50008C5.83331 7.8014 5.8653 8.09525 5.92669 8.37783C5.76107 8.34866 5.59064 8.33341 5.41665 8.33341C3.80581 8.33341 2.49998 9.63925 2.49998 11.2501C2.49998 12.667 3.51032 13.8479 4.84986 14.1117L5.00002 14.1372L5.0003 15.8147C2.66411 15.6044 0.833313 13.6411 0.833313 11.2501C0.833313 9.13808 2.26185 7.3597 4.20538 6.82851C4.53799 3.92309 7.00549 1.66675 9.99998 1.66675Z" />
  </svg>,
  'DownloadCloud',
);

export const ArrowRightIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.4763 9.16658L9.00631 4.69657L10.1848 3.51807L16.6666 9.99992L10.1848 16.4817L9.00631 15.3032L13.4763 10.8332H3.33331V9.16658H13.4763Z" />
  </svg>,
  'ArrowRight',
);

export const ArrowLeftIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.52369 9.16658L10.9937 4.69657L9.81519 3.51807L3.33335 9.99992L9.81519 16.4817L10.9937 15.3032L6.52369 10.8332H16.6667V9.16658H6.52369Z" />
  </svg>,
  'ArrowLeft',
);

export const FileUploadIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.5 3.33341H4.16667V16.6667H15.8333V6.66675H12.5V3.33341ZM2.5 2.49325C2.5 2.03679 2.87291 1.66675 3.33208 1.66675H13.3333L17.4998 5.83341L17.5 17.4938C17.5 17.9575 17.1292 18.3334 16.6722 18.3334H3.32783C2.87063 18.3334 2.5 17.954 2.5 17.5069V2.49325ZM10.8333 10.0001V13.3334H9.16667V10.0001H6.66667L10 6.66675L13.3333 10.0001H10.8333Z" />
  </svg>,
  'FileUpload',
);

export const ArrowDownDoubleIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99998 15.9702L15.1726 10.7976L13.9941 9.61913L9.99998 13.6132L6.00591 9.61913L4.82739 10.7976L9.99998 15.9702ZM9.99998 11.262L15.1726 6.0894L13.9941 4.91089L9.99998 8.90496L6.00591 4.91089L4.82739 6.0894L9.99998 11.262Z" />
  </svg>,
  'ArrowDownDouble',
);

export const ExpandDiagonalIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.5 2.5H11.25L13.7857 5.03574L11.0774 7.74407L12.2559 8.92258L14.9642 6.21426L17.5 8.75V2.5ZM2.5 17.5H8.75L6.21426 14.9642L8.92258 12.2559L7.74407 11.0774L5.03574 13.7857L2.5 11.25V17.5Z" />
  </svg>,
  'ExpandDiagonal',
);

export const CollapseDiagonalIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.5 11.0001H13V3.50008L16.0429 6.54297L19.2929 3.29297L20.7071 4.70718L17.4571 7.95718L20.5 11.0001ZM3.50008 13H11.0001V20.5L7.95718 17.4571L4.70718 20.7071L3.29297 19.2929L6.54297 16.0429L3.50008 13Z"></path>
  </svg>,
  'CollapseDiagonal',
);

export const TableIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 8H20V5H4V8ZM14 19V10H10V19H14ZM16 19H20V10H16V19ZM8 19V10H4V19H8ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3Z"></path>
  </svg>,
  'TableIcon',
);

export const ArrowUpDownIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.95821 6.62479L8.77971 7.8033L6.66737 5.69L6.66674 16.6667H5.00008L5.0007 5.69L2.88713 7.8033L1.70862 6.62479L5.83341 2.5L9.95821 6.62479ZM18.2915 13.3752L14.1667 17.5L10.042 13.3752L11.2205 12.1967L13.334 14.31L13.3334 3.33333H15L15.0007 14.31L17.113 12.1967L18.2915 13.3752Z" />
  </svg>,
  'ArrowUpDown',
);

export const ArrowLeftDoubleIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.02979 9.99997L9.20238 15.1726L10.3809 13.9941L6.38681 9.99997L10.3809 6.0059L9.20238 4.82739L4.02979 9.99997ZM8.73805 9.99997L13.9106 15.1726L15.0891 13.9941L11.0951 9.99997L15.0891 6.0059L13.9106 4.82739L8.73805 9.99997Z" />
  </svg>,
  'ArrowLeftDouble',
);

export const ArrowRightDoubleIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.9702 9.99997L10.7976 4.82739L9.61913 6.0059L13.6132 9.99997L9.61913 13.9941L10.7976 15.1726L15.9702 9.99997ZM11.262 9.99997L6.0894 4.82739L4.91089 6.0059L8.90496 9.99997L4.91089 13.9941L6.0894 15.1726L11.262 9.99997Z" />
  </svg>,
  'ArrowRightDouble',
);

export const ArrowRightWideIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.0262 10.0001L9.06978 2.52686L7.5968 3.30667L11.1404 10.0001L7.5968 16.6935L9.06978 17.4733L13.0262 10.0001Z" />
  </svg>,
  'ArrowRightWide',
);

export const ArrowLeftWideIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.97375 10.0001L10.9301 2.52686L12.4031 3.30667L8.85956 10.0001L12.4031 16.6935L10.9301 17.4733L6.97375 10.0001Z" />
  </svg>,
  'ArrowLeftWide',
);

export const ChatIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.80246 14.1667H16.6666V4.16667H3.33329V15.3208L4.80246 14.1667ZM5.37913 15.8333L1.66663 18.75V3.33333C1.66663 3.11232 1.75442 2.90036 1.9107 2.74408C2.06698 2.5878 2.27895 2.5 2.49996 2.5H17.5C17.721 2.5 17.9329 2.5878 18.0892 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33333V15C18.3333 15.221 18.2455 15.433 18.0892 15.5893C17.9329 15.7455 17.721 15.8333 17.5 15.8333H5.37913Z" />
  </svg>,
  'Chat',
);

export const SendPlaneIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.1058 2.46418L13.5608 18.3692C13.4358 18.81 13.165 18.83 12.9633 18.4275L9.16662 10.8333L1.60245 7.80835C1.17745 7.63751 1.18329 7.38335 1.63079 7.23418L17.5358 1.93335C17.9766 1.78668 18.2291 2.03251 18.1058 2.46418ZM15.8625 4.24835L5.67662 7.64168L10.3741 9.52085L12.9075 14.5875L15.8625 4.24835Z" />
  </svg>,
  'SendPlane',
);

export const SquaresFourIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5H8.33333C8.55435 2.5 8.76631 2.5878 8.92259 2.74408C9.07887 2.90036 9.16667 3.11232 9.16667 3.33333V8.33333C9.16667 8.55435 9.07887 8.76631 8.92259 8.92259C8.76631 9.07887 8.55435 9.16667 8.33333 9.16667H3.33333C3.11232 9.16667 2.90036 9.07887 2.74408 8.92259C2.5878 8.76631 2.5 8.55435 2.5 8.33333V3.33333ZM2.5 11.6667C2.5 11.4457 2.5878 11.2337 2.74408 11.0774C2.90036 10.9211 3.11232 10.8333 3.33333 10.8333H8.33333C8.55435 10.8333 8.76631 10.9211 8.92259 11.0774C9.07887 11.2337 9.16667 11.4457 9.16667 11.6667V16.6667C9.16667 16.8877 9.07887 17.0996 8.92259 17.2559C8.76631 17.4122 8.55435 17.5 8.33333 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V11.6667ZM10.8333 3.33333C10.8333 3.11232 10.9211 2.90036 11.0774 2.74408C11.2337 2.5878 11.4457 2.5 11.6667 2.5H16.6667C16.8877 2.5 17.0996 2.5878 17.2559 2.74408C17.4122 2.90036 17.5 3.11232 17.5 3.33333V8.33333C17.5 8.55435 17.4122 8.76631 17.2559 8.92259C17.0996 9.07887 16.8877 9.16667 16.6667 9.16667H11.6667C11.4457 9.16667 11.2337 9.07887 11.0774 8.92259C10.9211 8.76631 10.8333 8.55435 10.8333 8.33333V3.33333ZM10.8333 11.6667C10.8333 11.4457 10.9211 11.2337 11.0774 11.0774C11.2337 10.9211 11.4457 10.8333 11.6667 10.8333H16.6667C16.8877 10.8333 17.0996 10.9211 17.2559 11.0774C17.4122 11.2337 17.5 11.4457 17.5 11.6667V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H11.6667C11.4457 17.5 11.2337 17.4122 11.0774 17.2559C10.9211 17.0996 10.8333 16.8877 10.8333 16.6667V11.6667ZM12.5 4.16667V7.5H15.8333V4.16667H12.5ZM12.5 12.5V15.8333H15.8333V12.5H12.5ZM4.16667 4.16667V7.5H7.5V4.16667H4.16667ZM4.16667 12.5V15.8333H7.5V12.5H4.16667Z" />
  </svg>,
  'SquaresFour',
);
